<template>
  <div v-if="isLoaded" class="page-grid">
    <StatusBar :farm="farm"></StatusBar>
    <EventsCard :farm="farm"></EventsCard>
    <OfficeTasksCard :farm="farm"></OfficeTasksCard>
    <SalesCard :farm="farm"></SalesCard>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import util from '../../util'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import StatusBar from '@/components/StatusBar.vue'
import TextButton from '@/components/ui/TextButton.vue'
import EventsCard from '@/components/EventsCard.vue'
import OfficeTasksCard from '@/components/OfficeTasksCard.vue'
import SalesCard from "@/components/SalesCard.vue"

@Options({
  components: {
    OfficeTasksCard, EventsCard, SalesCard, ValueMeter, FarmStatusCard, StatusBar, TextButton
  },
  props: {
    farm: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class OfficeView extends Vue {
  isLoaded = false
  farm!: Farm
}
</script>

<style scoped lang="scss">
$office-mobile-width: 1000px;

.page-grid {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    "s s"
    "t p"
    "t e";

  @media screen and (max-width: $mobile-width){
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    grid-template-areas:
      "s"
      "t"
      "p"
      "e";
  }
}

.status-bar {
  grid-area: s;
}

.events-card {
  grid-area: e;
}

.tasks-card {
  grid-area: t;
}

.sales-card {
  grid-area: p;
}
</style>
